import React from "react"
import Button from "@mui/material/Button"
import CircularProgress from "@mui/material/CircularProgress"

import { reduxForm } from "redux-form"
import { UserDetails, userValidate } from "../components/UserDetails"

const RegisterForm = ({ brandColor, handleSubmit, invalid, pristine, submitting }) => {
  // console.log("bc: ", brandColor)
  return (
    <form onSubmit={handleSubmit}>
      <UserDetails
        name="userDetails"
        brandColor={brandColor}
      />

      <div>
        <Button
          type="submit"
          className="fullWidthButton"
          variant="contained"
          color="primary"
          size="large"
          disabled={invalid || pristine || submitting}>
          {submitting ? <CircularProgress size={24} /> : "Register for free 14-day trial"}
        </Button>
      </div>
    </form>
  )
}

export default reduxForm({
  form: "register",
  validate: userValidate,
  touchOnChange: true,
  touchOnBlur: false
}
)(RegisterForm)